import React from "react"
import { nivoTheme } from "./chartTheme"

export interface ChartTooltipRow {
  key: string
  colour: string
  value: string
  /** The series name; left out when the chart has one series. */
  label?: string
}

/**
 * The hover card of the chart tiles: the category on top, then one row per
 * series with a short line key in the series colour, the value first and
 * the series name after it. Text stays in ink.
 */
const ChartTooltip: React.FC<{ title?: string; rows: ChartTooltipRow[] }> = ({
  title,
  rows,
}) => (
  <div className="dq-chart-tip" style={nivoTheme.tooltip?.container}>
    {title && <div className="dq-chart-tip__title">{title}</div>}
    {rows.map((r) => (
      <div key={r.key} className="dq-chart-tip__row">
        <span className="dq-chart-tip__key" style={{ background: r.colour }} />
        <span className="dq-chart-tip__value">{r.value}</span>
        {r.label && <span className="dq-chart-tip__label">{r.label}</span>}
      </div>
    ))}
  </div>
)

export default ChartTooltip
